import type { TextAndServiceContent } from '@/core/types';

import { TextAndService } from '@/containers/blocks/features';

export default function generate({
  content,
  className,
}: {
  content: TextAndServiceContent;
  className?: string;
}) {
  return (
    <TextAndService
      title={content.title}
      description={content.description}
      buttons={content.buttons || undefined}
      service={content.service}
      className={className}
    />
  );
}
